/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'ARCHIVE',
  'ARCHIVE_AND_REUSE',
  'CAN_START_CHAT_CHANGED',
  'CLEAR_DRAFT_ANNOUNCEMENT',
  'CREATE_GROUP',
  'DESTROY_GROUP_SCHEDULED_MESSAGE',
  'FETCH_DELIVERY_SUMMARY_SUCCEEDED_USERS',
  'GROUPS_UPDATED',
  'LIST_GROUP_MESSAGES',
  'LIST_GROUP_SCHEDULED_MESSAGES',
  'LIST_GROUPS',
  'LIST_ARCHIVED_GROUPS',
  'LOAD_GROUP',
  'REMOVE_ALL_SUBSCRIBERS',
  'RESET_STORE',
  'RESIGN_OWNERSHIP',
  'SAVE_AND_SHOW_DRAFT_ANNOUNCEMENT',
  'FINISH_SHOWING_DRAFT',
  'RESTORE',
  'REUSE',
  'SEND_AGAIN',
  'SEND_GROUP_MESSAGE_ERROR',
  'SEND_GROUP_MESSAGE',
  'SEND_GROUP_SCHEDULED_MESSAGE_ERROR',
  'SEND_GROUP_SCHEDULED_MESSAGE',
  'SUBSCRIBED',
  'UNSUBSCRIBED',
  'UPDATE_GROUP',
  'UPDATED_GROUP_SCHEDULED_MESSAGE',
  'CHANGE_ORG',
  'JOIN_GROUP_DURING_SETUP',
  'CREATE_GROUP_DURING_SETUP',
  'CLEAR_GROUP_CREATED_DURING_SETUP',
  'CLEAR_GROUPS_JOINED_DURING_SETUP',
]);

export const LoadingStates = enumerate(['NOT_STARTED', 'LOADING', 'LOADED']);
